// extracted by mini-css-extract-plugin
module.exports = {"detailsList":"DetailsList_detailsList__3_Jpu","detailsListContainer":"DetailsList_detailsListContainer__2gZPG"};